<template>
  <div :class="previewClass">
    <article class="markdown-body">
      <VueShowdown
        :markdown="content"
        flavor="github"
        :options="{
          emoji: true,
          prefixHeaderId: 'rec-',
          parseImgDimensions: true,
          simplifiedAutoLink: true,
          excludeTrailingPunctuationFromURLs: true,
          strikethrough: true,
          ghMentions: false,
          smoothLivePreview: true,
        }"
        :extensions="[extensions]"
      />
    </article>
  </div>
</template>

<script>
import "@/assets/css/github-markdown.css";
import { getFileContent } from "@/api/drive/drive";
import { VueShowdown } from "vue-showdown";
export default {
  name: "markdownPreview",
  components: {
    VueShowdown,
  },
  data() {
    return {
      content: "",
      extensions: [
        {
          type: "output",
          filter: function (source) {
            const regex =
              /(<h([1-6]).*?id="([^"]*?)".*?>(.+?)<\/h[1-6]>)|(<p>(.*?)\[toc\](.*?)<\/p>)/g;

            // find and collect all headers and [toc] node;
            const collection = [];
            source = source.replace(/\[TOC\]/gi, "[toc]");
            source.replace(regex, (wholeMatch, _, level, anchor, text) => {
              // console.log(wholeMatch, level, anchor, text);
              if (
                wholeMatch === "<p>[toc]</p>" ||
                /<p>(.*?)\[toc\](.*?)<\/p>/.test(wholeMatch)
              ) {
                collection.push({ type: "toc" });
              } else {
                text = text.replace(/<[^>]+>/g, "");
                collection.push({
                  type: "header",
                  anchor: anchor,
                  level: Number(level),
                  text: text,
                });
              }
              return "";
            });
            // console.log(collection);

            // calculate toc info
            const tocCollection = [];
            collection.forEach((item, index) => {
              if (item.type === "toc") {
                if (
                  collection[index + 1] &&
                  collection[index + 1].type === "header"
                ) {
                  const headers = [];
                  const levelToToc = collection[index + 1].level;
                  for (let i = index + 1; i < collection.length; i++) {
                    if (collection[i].type === "toc") {
                      break;
                    }
                    const level = collection[i].level;
                    // 根据不同level判断
                    if (level >= levelToToc) {
                      headers.push(collection[i]);
                    } else {
                      break;
                    }
                  }
                  tocCollection.push(headers);
                } else {
                  tocCollection.push([]);
                }
              }
            });
            // console.log(tocCollection[0], tocCollection[1]);

            // replace [toc] node in source
            source = source.replace(/<p>(.*?)\[toc\](.*?)<\/p>/g, () => {
              let headers = tocCollection.shift();

              headers.reverse();

              // console.log(headers);
              if (headers && headers.length) {
                let tagObj = {};
                let prevLevel = null;
                headers.map((item) => {
                  let before = "",
                    after = "";
                  if (!prevLevel || item.level == prevLevel) {
                    before = `<li><a href="#${item.anchor}">${item.text}</a>`;
                    after = "</li>";
                    if (tagObj[item.level]) {
                      tagObj[item.level].unshift(before + after);
                    } else {
                      tagObj[item.level] = [before + after];
                    }
                  } else if (item.level < prevLevel) {
                    before = `<li><a href="#${item.anchor}">${item.text}</a><ol>`;
                    after = "</ol></li>";
                    if (!tagObj[item.level]) {
                      tagObj[item.level] = [];
                    }
                    tagObj[item.level].unshift(
                      before + tagObj[prevLevel].join("") + after
                    );
                    tagObj[prevLevel] = [];
                  } else if (item.level > prevLevel) {
                    before = `<li><a href="#${item.anchor}">${item.text}</a>`;
                    after = "</li>";
                    tagObj[item.level] = [before + after];
                  }
                  // console.log(item.level, tagObj[item.level]);
                  prevLevel = item.level;
                });
                // console.log(tagObj, tagObj[prevLevel].join(""));
                const str = `<ul class="showdown-toc">${tagObj[prevLevel].join(
                  ""
                )}</ul>\n`;
                return str;
              }
              return "";
            });
            return source;
          },
        },
      ],
    };
  },
  created() {
    // console.log("初始化markdownPreview预览组件");
    this.$nextTick(() => {
      this.getFileContent();
    });
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    },
  },
  methods: {
    getFileContent() {
      getFileContent(this.previewData.preview_path)
        .then((res) => {
          this.content = res;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  destroyed() {
    // console.log("销毁markdownPreview预览组件");
    this.$store.commit("setPreviewData", {
      preview_path: "",
      previewer: "unknowPreview",
    });
  },
};
</script>

<style scoped>
.preview-fullscreen {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.preview-fullscreen-top {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.preview-inside {
  width: 460px;
  height: 280px;
  overflow: auto;
}

.markdown-warp {
  height: 100%;
  overflow: auto;
}
.markdown-body {
  box-sizing: border-box;
  min-width: 200px;
  max-width: 980px;
  margin: 0 auto;
  padding: 45px;
  overflow: auto;
}
</style>